import {
  ConfirmationBox,
  ConfirmationBoxProps,
  RadioGroup,
  RadioGroupOption,
  ToggleName,
} from '@infotech-soe/erp-ui-kit';
import React, { memo, useCallback, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';

import { useStyles as useDialogStyles } from '../dialogs/styles';

import { PageOrientation } from './PivotReport';

type Props = Pick<ConfirmationBoxProps, 'open' | 'title' | 'onCancel'> & {
  onSelect: (orientation: PageOrientation) => void;
};

const PivotSelectOrientationForm = (props: Props) => {
  const { open, title, onCancel, onSelect } = props;
  const dialogClasses = useDialogStyles();
  const { formatMessage } = useIntl();
  const [value, setValue] = useState<PageOrientation>('landscape');

  const handleChange = useCallback((v: ToggleName) => {
    if (v) setValue(v as PageOrientation);
  }, []);

  const options = useMemo<Array<RadioGroupOption<PageOrientation>>>(
    () =>
      (['landscape', 'portrait'] as const).map(orientation => ({
        value: orientation,
        label: formatMessage({
          id: `core.pivotReport.orientation.${orientation}`,
          defaultMessage: orientation,
        }),
      })),
    [formatMessage]
  );

  return (
    <ConfirmationBox
      className={dialogClasses.dialog}
      open={open}
      title={title}
      onConfirm={() => onSelect(value)}
      onCancel={onCancel}
      onClose={onCancel}
    >
      <div className="m-pa-xl">
        <RadioGroup
          borderless
          columns={2}
          options={options}
          required
          value={value}
          onChange={handleChange}
        />
      </div>
    </ConfirmationBox>
  );
};

export default memo(PivotSelectOrientationForm);
